import _debounce from 'lodash/debounce';
import Glide from '@glidejs/glide';
import $ from 'jquery';

// todo - this needs to be enabled once the hardcoded JS/CSS etc are taken out of the CMS
// Until then, JS in ES5 format for easy portability and return the below since it's also embedded in the page...
//return;


(function($) {

   var jokes = [
      {
         'line_1': 'Q: What’s a propeller’s favourite exercise?',
         'line_2': 'A: Spin class',
      },
      {
         'line_1': 'Q: Why did the helicopter buy new blades?',
         'line_2': 'A: It was getting a bit airy.',
      },
      {
         'line_1': 'Q: What is the helicopter’s favourite song?',
         'line_2': 'A: Don’t Look Back In Hangar',
      },
      {
         'line_1': 'Q: Why do helicopter’s wake up at the crack of dawn?',
         'line_2': 'A: Because the whirly bird catches the worm.',
      },
      {
         'line_1': 'Q: What do helicopters and cats have in common?',
         'line_2': 'A: They always land on their pads.',
      },
      {
         'line_1': 'Q: Why was the helicopter embarrassed?',
         'line_2': 'A: Because he was flying low.',
      },
      {
         'line_1': 'Q: Why was the helicopter cold?',
         'line_2': 'A: It left its coat on the hangar.',
      },
      {
         'line_1': 'I made a film about helicopters.',
         'line_2': 'It really took off.',
      },
   ];

   function selectXmasCrackerPrize() {
      var prize = window.localStorage.getItem('xmas-cracker-prize');
      if(!prize) {
         var r = Math.random() * 100;
         if(r < 20) {
            window.localStorage.setItem('xmas-cracker-prize', 'keyring');
         }
         else if (r < 70) {
            var i = Math.floor(Math.random() * 8);
            window.localStorage.setItem('xmas-cracker-prize', 'joke,' + i);
         }
         else {
            window.localStorage.setItem('xmas-cracker-prize', 'video');
         }
         return selectXmasCrackerPrize();
      }
      switch(prize) {
         case 'keyring':
            showKeyring();
            break;
         case 'video':
            showVideo();
            break;
         default:
            var i = +prize.substr(5);
            showJoke(i);
      }
   }

   function showJoke(i) {
      var joke = jokes[i] || jokes[0]; // fall back to first if no match
      $('.xmas-cracker .joke .line-1').text(joke.line_1);
      $('.xmas-cracker .joke .line-2').text(joke.line_2);
      $('.xmas-cracker .joke').show();
      $('.xmas-cracker .top-line').show();
      $('.xmas-cracker .bottom-line').show();
   }

   function showKeyring() {
      $('.xmas-cracker .keyring').show();
      $('.xmas-cracker .top-line').text('Congratulations you have won');
   }

   function showVideo() {
      $('.xmas-cracker .video').show();
      $('.xmas-cracker .top-line').text('Congratulations you have won a');
      $('.xmas-cracker .bottom-line').text('Christmas video message from our Aircrew');
   }

   function showPrize() {
      $('.xmas-cracker .prize').delay(2500).fadeIn(1500);
   }

   $(function () {
      $('.xmas-cracker .cracker-button').click(function(ev) {
         $('.xmas-cracker .cracker').addClass('cracker--active');
         selectXmasCrackerPrize();
         showPrize();
      });
   });

})($);
